var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.037,
    height: 38.899,
    viewBox: "0 0 34.037 38.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.277,
    y1: 0.156,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787cfe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-26.441-39.189a9.733,9.733,0,0,1-9.041,6.139,9.733,9.733,0,0,1-9.041-6.139,2.435,2.435,0,0,1-1.9-2.37v-4.862a2.429,2.429,0,0,1,2.431-2.431h.919a9.69,9.69,0,0,1,7.59-3.647,9.69,9.69,0,0,1,7.59,3.647h.919a2.429,2.429,0,0,1,2.431,2.431v4.862A2.428,2.428,0,0,1-26.441-39.189ZM-52.5-15.857A13.544,13.544,0,0,1-38.954-29.4h6.944A13.544,13.544,0,0,1-18.463-15.857,2.257,2.257,0,0,1-20.72-13.6H-50.244A2.257,2.257,0,0,1-52.5-15.857Zm26.492-1.512a.308.308,0,0,0,.555-.19,11.623,11.623,0,0,0-2.287-6.853.3.3,0,0,0-.463-.008,12.1,12.1,0,0,0-2.72,6.8.309.309,0,0,0,.494.266c.137-.106.311-.258.5-.425.7-.615,1.694-1.482,2.408-1.482a12.929,12.929,0,0,1,1.512,1.9ZM-41.56-45.206a1.219,1.219,0,0,0-1.216,1.216,1.219,1.219,0,0,0,1.216,1.216H-29.4a1.219,1.219,0,0,0,1.216-1.216A1.219,1.219,0,0,0-29.4-45.206Z",
    transform: "translate(52.5 52.5)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.9df24bc04da823420793243fdbcde021.svg";
export { ForwardRef as ReactComponent };